import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  FormatCurrency,
  FormatDate,
  isNullOrEmpty,
  IsNumber
} from 'helpers/FormatData.js';
import { Link } from 'react-router-dom';
import IconButton from 'componentes/common/IconButton';

const QuejaInfo = ({
  queja,
  determinante,
  subCustomer,
  setOpenModalFolioExt,
  setOpenModalExpediente,
  setOpenModalProducto
}) => {
  return (
    <Card className="mb-3">
      <Card.Header>
        <Row className="align-items-center">
          <Col>
            <h5 className="mb-0">Detalles de Queja</h5>
          </Col>

          <Col xs="auto">
            {/* <IconButton
              iconClassName="fs-11 me-1"
              variant="falcon-default"
              size="sm"
              icon="pencil-alt"
            >
              Modificar
            </IconButton> */}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="bg-body-tertiary border-top">
        <Row>
          <Col lg xxl={6}>
            <Col xs="auto">
              <IconButton
                className="  me-1 mb-1"
                variant="light"
                size="sm"
                icon="pencil-alt"
                iconAlign="left"
                onClick={() => setOpenModalExpediente(true)}
              >
                Expediente
              </IconButton>
            </Col>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Delegacion</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.delegacionprofeco.nombre}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Cliente</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {subCustomer.cliente.razonsocial}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Subcliente</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {determinante.subcliente.descripcion} -
                  {determinante.subcliente.determinanate}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Determinante</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {determinante.determinante} - {determinante.unidad}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Municipio</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {determinante.municipio.descripcion}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Fecha Recepcion</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {FormatDate(queja.fecharecepcionjmm)}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Fecha Compra</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.quejadetalle?.fechacompra
                    ? FormatDate(queja.quejadetalle?.fechacompra)
                    : 'No Capturada'}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Nombre Seller</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.quejadetalle?.seller || 'No Capturado'}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Fecha Devolucion</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.quejadetalle?.fechadevolucion
                    ? FormatDate(queja.quejadetalle?.fechadevolucion)
                    : 'No Capturada'}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Formato Queja</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.FormatoQueja.formato}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Folio Oracle</p>
              </Col>
              <Col>
                <Link
                  className="mb-1 fst-italic fw-semibold"
                  to="#"
                  onClick={e => {
                    e.preventDefault();
                    setOpenModalFolioExt(true);
                  }}
                >
                  {isNullOrEmpty(queja.quejadetalle?.folioext)
                    ? 'No Capturado'
                    : queja.quejadetalle?.folioext}
                </Link>
              </Col>
            </Row>
          </Col>

          <Col lg xxl={{ span: 5, offset: 1 }} className="mt-4 mt-lg-0">
            <Row>
              <Col xs="auto">
                <IconButton
                  className="  me-1 mb-1"
                  variant="light"
                  size="sm"
                  icon="pencil-alt"
                  iconAlign="left"
                  onClick={() => setOpenModalProducto(true)}
                >
                  Informacion de Producto
                </IconButton>
              </Col>
            </Row>

            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Producto</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.tipoproductoqueja.clave}-
                  {queja.tipoproductoqueja.descripcion}
                </p>
              </Col>
            </Row>

            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Clasificacion</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.clasificacionqueja.clave}-
                  {queja.clasificacionqueja.descripcion}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Clas. Profeco</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.clasificacionquejaprofeco?.descripcion}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Monto Pagado</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {FormatCurrency(
                    queja.montopagado == 0 &&
                      IsNumber(queja.tel1.replace(',', ''))
                      ? queja.tel1.replace(',', '')
                      : queja.montopagado
                  )}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Monto Real</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {FormatCurrency(
                    queja.montoreal == 0 &&
                      IsNumber(queja.tel2.replace(',', ''))
                      ? queja.tel2.replace(',', '')
                      : queja.montoreal
                  )}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Facturacion</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.statusFacturacion.descripcion}
                </p>
              </Col>
            </Row>

            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Tipo de Evento</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.tipoevento?.clave} / {queja.tipoevento?.descripcion}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5} sm={4}>
                <p className="fw-normal mb-1">Numero de Pedido</p>
              </Col>
              <Col>
                <p className="mb-1 fst-italic fw-semibold">
                  {queja.numeropedido ?? 'No Capturado'}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
QuejaInfo.propTypes = {
  queja: PropTypes.object.isRequired,
  determinante: PropTypes.object.isRequired,
  subCustomer: PropTypes.object.isRequired,
  setOpenModalFolioExt: PropTypes.func.isRequired,
  setOpenModalExpediente: PropTypes.func,
  setOpenModalProducto: PropTypes.func
};
export default QuejaInfo;
